<template>
  <v-menu v-if="actions && actions.length > 1" offset-y light class="z4">
    <template #activator="{ on }">
      <v-btn
        outlined
        dark
        v-on="on"
      >
        Outils
        <v-icon right dark>mdi-wallet-travel</v-icon>
      </v-btn>
    </template>

    <v-list light class="mt-2 overflow-auto max-height-300">
      <v-list-item
        v-for="action in actions"
        v-if="action.condition !== false"
        :key="action.action"
        class="pointer"
        @click="changeToPage(action)"
      >
        <v-list-item-title>{{ action.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { ref } from '@vue/composition-api';
import { isProd } from '@/helpers/utils';

import router from '@/router';

export default {
  name: 'ActionPicker',
  setup () {
    const actions = ref([
      { label: 'Soins planifiés', action: '/treatments' },
      { label: 'Demandes d\'achats', action: '/customers' },
      { label: 'Liste des clients', action: '/plannerCustomer' },
      { label: 'Licences', action: '/licenses' },
      { label: 'Email', action: '/email' },
      { label: 'Affectation en masse', action: '/products' },
      { label: 'Chutes', action: '/falls' },
      { label: 'Vacances et jours fériés', action: '/holidays' },
      { label: 'Séance / Produit', action: '/sessionProduct' },
      { label: 'Pensions', action: '/pensions', condition: !isProd }
    ]);

    const changeToPage = async action => {
      router.push({ path: action.action });
    };

    return { actions, changeToPage };
  }
};
</script>
